/**
 * Storefront Mini App entry point.
 *
 * Order matters: import the shared theme once, initialize the Telegram SDK (mounts
 * Back/Main buttons, theme, viewport) *before* React renders so the button hooks
 * find a mounted SDK, then mount the React tree.
 */
import "@melusine/shared-ui/theme.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { getStartParam, initTelegram } from "@melusine/shared-telegram";
import { initTheme } from "@features/theme";
import { applyDeepLink } from "@shared/router";

import { App } from "./App";

// Apply the persisted theme before first paint so there's no flash of the default look.
initTheme();

initTelegram();

// Resolve bot deep-links (real-path web_app URLs and ``startapp=order_<id>``) into a
// clean hash route *before* the router reads the hash. Must run once, pre-render.
applyDeepLink(getStartParam);

const container = document.getElementById("root");
if (container === null) {
  throw new Error('Root element "#root" not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
